import * as LegalsConstants from '../constants/Legals';

const initialState = {
  showDialog: false,
  institutionName: "",
  address: "",
  customerName: "",
  type: "",
  link: "",
  update: false
};

export function legals(state = initialState, action) {
  switch (action.type) {
    case LegalsConstants.SHOW_DIALOG:
      return Object.assign({}, state, {showDialog: true}, action.legalInformation);
    case LegalsConstants.HIDE_DIALOG:
      return Object.assign({}, initialState);
    default:
      return state;
  }
}
